// src/store/sidebarStore.ts
import { navList } from '@/pages/Home/components/Catalog';
import { create } from 'zustand';

interface SidebarState {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  changeSidebarState: (state: boolean) => void;
}
const isMobileOrPad = window.innerWidth <= 1024;

const MY_CATALOG_PATH = navList?.map(({ to }) => {
  if (to === '/') {
    return '/';
  }
  return `/${to}`;
});

const inJeneratePath = MY_CATALOG_PATH.includes(location.pathname) || location.pathname.includes('/folder');

const useSidebarStore = create<SidebarState>((set) => ({
  isSidebarOpen: isMobileOrPad || !inJeneratePath,
  toggleSidebar: () => {
    if (!isMobileOrPad) {
      set((state) => ({ isSidebarOpen: !state.isSidebarOpen }));
    }
  },
  changeSidebarState: (state: boolean) => {
    if (!isMobileOrPad) {
      set({ isSidebarOpen: state });
    }
  },
}));

export default useSidebarStore;
